module.exports = __webpack_public_path__ + "static/media/oppo-indonesia-7.769d0486.jpg";